import { render, staticRenderFns } from "./reclaim-bucket.vue?vue&type=template&id=88d38f72"
import script from "./reclaim-bucket.vue?vue&type=script&lang=js"
export * from "./reclaim-bucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports